import { createContext, useState } from "react";

export const ReportsContext = createContext();

const intialReportFilters = {
   status: "",
    matchseekerName: "",
    matchseekerMobile: "",
    matchmakerName: "",
    matchmakerMobile: "",
    startDate: "",
    endDate: "",

}

export const ReportsProvider = ({ children }) => {

  const [reportsSearchTerm, setReportsSearchTerm] = useState("");
  const [reportsFilters, setReportsFilters] = useState(intialReportFilters);
  const [ContextCurrentPage, contextSetCurrentPage] = useState(1);
  const [ContextTotalPages, contextSetTotalPages] = useState(0);
  const [Contextlimit] = useState(5);
  const [ContextReload, ContextSetReload] = useState(false);

  return (
    <ReportsContext.Provider
      value={{
        reportsSearchTerm,
        setReportsSearchTerm,
        setReportsFilters,
        reportsFilters,
        intialReportFilters,
        ContextCurrentPage,
        contextSetCurrentPage,
        ContextTotalPages,
        contextSetTotalPages,
        Contextlimit,
        ContextReload,
        ContextSetReload,
      }}
    >
      {children}
    </ReportsContext.Provider>
  );
};
